(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.dades.controller:DadesCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes.main.submain.dades')
    .controller('ProductesMainDadesCtrl', ProductesMainDadesCtrl);

  function ProductesMainDadesCtrl(producteData,$window, $rootScope,$stateParams,$state) {
    var vm = this;
    vm.ctrlName = 'ProductesMainDadesCtrl';
    vm.producte=producteData.data;

    //functions
    vm.changeToForm = changeToForm;
    vm.deleteElem = deleteElem;
    vm.issuperadmin=  $rootScope.issuperadmin;


    function deleteElem() {
      $window.scrollTo(0, 0);
      $rootScope.$broadcast('productes.main.showOptionSubmenu', {'show': false});
      $rootScope.$broadcast('productes.main.delete', vm.producte);
    }

    function changeToForm() {
      $window.scrollTo(0, 0);
      $rootScope.$broadcast('productes.main.showOptionSubmenu', {'show': false});
      $rootScope.$broadcast('productes.main.edit', vm.producte);
    }
   

   if (angular.isUndefined($stateParams.idProducte) || $stateParams.idProducte === null || !$stateParams.idProducte) {
      $rootScope.$broadcast('productes.main.showOptionSubmenu', {'show': false});
      $state.go('productes.main', $stateParams, {'reload': 'productes.main.submain'});
    }
    else {
      $rootScope.$broadcast('productes.main.showOptionSubmenu', {'show': true});
    }
  }
}());
